// home.component.ts
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import {NgIf} from "@angular/common";

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
  standalone: true,
  imports: [
    NgIf
  ]
})
export class HomeComponent {
  currentPage = 1;
  totalPages = 1;

  constructor(private router: Router) {}

  goToPage(page: number) {
    this.currentPage = page;
  }

  goToPreviousPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
    }
  }

  goToNextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
    }
  }

  goToCardDetails() {
    this.router.navigate(['/card-list']);
  }
}
